<template>
  <div class="content" id="absensi" v-on:click="sectionClicked">
    <div class="camera" ref="camera">
      <div class="backBtn" v-on:click="$router.back()"></div>
      <div class="logo"></div>
      <div class="location" :class="{loading: loadingGeolocation,
        unsupported: geolocationUnsuported}"
        v-on:click="getPosition">
        <div class="loc-l l1"></div>
        <div class="loc-l l2"></div>
        <div class="loc-l l3"></div>
        <div class="loc-l l4"></div>
      </div>
      <div class="box" :class="{unsupported: cameraUnsupported}"
        ref="box">
        <canvas id="canvas" willReadFrequently="true"></canvas>
        <div class="camera-unsupported" v-if="cameraUnsupported">
          Camera not supported on your device
        </div>
      </div>
      <video autoplay="true" id="video" muted playsinline></video>
      <div class="flash"></div>
      <div class="camera-change" v-on:click="changeCamera"></div>
    </div>
    <div class="info" ref="info" :class="{hasError: apiError,
      open: userInfoOpen}">
      <div class="title">
        <div class="handle"></div>
        <h4>{{event && event.name ? event.name : '...'}}</h4>
      </div>
      <div class="user-cnt">
        <div class="loading-user" v-if="loading"></div>
        <div class="please-take-photo error" v-else-if="apiError">
          <p>{{apiError}}</p>
          <button class="btn btnPrimary" v-on:click="tryAgain">Coba Lagi</button>
        </div>
        <div class="please-take-photo" v-else-if="!user">
          <p>Silahkan arahkan kamera pada QR Code
            undangan atau masukan kode seacara manual.</p>
          <button class="input-manual" v-on:click="manualInput">Masukan Code</button>
        </div>
        <div class="user-main-cnt" v-else>
          <div class="user-main">
            <div class="avatar" v-if="user.avatarHd"
              :style="{'background-image': `url(${user.avatarHd})`}"></div>
            <div class="avatar no-avatar" v-else></div>
            <p class="tyh">{{user.sapaan || 'YTH.'}}</p>
            <h4>{{user.name}}</h4>
            <p class="position" v-if="user.jabatan || user.organization">
              {{user.jabatan || ''}}
              {{user.organization || ''}}
            </p>
            <div class="absen-sukses" v-if="user.attendances && user.attendances.length > 0">
              Peserta sudah melakukan absensi pada
              <b>{{user.attendances[0].dateCreated * 1000 | moment('D MMM YYYY HH:mm') }}</b>
            </div>
            <div class="absen-error" v-if="absenError">{{absenError}}</div>
            <div class="user-info">
              <div class="user-info-item">
                <span class="info-label">Nama Acara</span>
                <span class="the-info">{{event && event.name ? event.name : '...'}}</span>
              </div>
              <div class="user-info-item">
                <span class="info-label">Tanggal absen</span>
                <span class="the-info">{{new Date() | moment('D MMM YYYY HH:mm')}}</span>
              </div>
            </div>
          </div>
          <div class="btnCnt">
            <button class="btn btnSecondary" v-on:click="tryAgain"
              v-if="!saving"><span v-if="user.absenRecorded">Tutup</span><span
              v-else>Batal</span></button>
            <button class="btn btnPrimary" v-on:click="catatAbsen" v-if="!user.absenRecorded"
              :class="{btnLoading: saving}"><span>Absen Masuk</span></button>
          </div>
        </div>
      </div>
    </div>
    <MediaInputer ref="mediaInputer"/>
    <ThankYou ref="thankYou"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MediaInputer from '@/components/MediaInputer.vue';
import ThankYou from '@/components/ThankYou.vue';

export default {
  name: 'absensi',
  components: { MediaInputer, ThankYou },
  data() {
    return {
      cameraUnsupported: false,
      geolocationUnsuported: false,
      loadingGeolocation: true,
      pos: { lat: 0, lng: 0 },
      flashAnimate: false,
      ctx: null,
      facing: 'environment',
      absenError: null,
      loading: false,
      apiError: null,
      userInfoOpen: false,
      user: null,
      scanner: null,
      activeCameraId: null,
      cameras: [],
      scans: [],
      qrReader: new QrCode(),
      qrScanned: false,
      saving: false,
      eventId: null,
      event: null,
    };
  },
  computed: {
    ...mapState(['title']),
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    doNothing() {},
    sectionClicked() {
      this.priceInfoOpen = false;
    },
    changeCamera() {
      this.facing = this.facing === 'environment' ? 'user' : 'environment';
      this.startCamera();
    },
    manualInput() {
      this.$refs.mediaInputer.open({
        title: 'Masukan Kode QR',
        placeholder: 'Kode QR',
        action: 'Temukan Undangan',
      }, (b, c) => {
        if (!b) return;
        this.getAbsensi(c);
      });
    },
    capture() {
      if (this.qrScanned || this.title !== 'QR Scaner Attendance') return;

      /**
       * Set canvas width and height based on pixel on screen
       *
       */
      canvas.width = this.$refs.box.offsetWidth;
      canvas.height = this.$refs.box.offsetHeight;

      /**
       * Add width tmp to calculate canvas relative to video size
       *
       */
      const canvasTmpWidth = (video.videoWidth >= video.videoHeight)
        ? canvas.width * video.offsetWidth / video.videoWidth
        : canvas.width * video.offsetHeight / video.videoHeight;

      /**
       * Create canvas context if not defined
       *
       */
      if (!this.ctx) this.ctx = canvas.getContext('2d');

      /**
       * Draw the image to canvas
       *
       */
      this.ctx.drawImage(video, -(video.videoWidth / 2) + (canvasTmpWidth / 2),
        (-(video.videoHeight / 2) + (canvasTmpWidth / 2)) + 20,
        video.videoWidth, video.videoHeight);
      this.qrReader.decode(this.ctx.getImageData(0, 0, canvas.width, canvas.height));

      /**
       * Capture for every 50 ms
       *
       */
      captureTimer = setTimeout(() => {
        this.capture();
      }, 5);
    },

    /**
     * Calculate aspect ration between two bounding box
     *
     */
    calcAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
      const ratio = Math.max(maxWidth / srcWidth, maxHeight / srcHeight);
      return { width: srcWidth * ratio, height: srcHeight * ratio };
    },
    getPosition() {
      if (!navigator.geolocation) {
        this.geolocationUnsuported = true;
        this.loadingGeolocation = false;
        return;
      }
      this.loadingGeolocation = true;
      navigator.geolocation.getCurrentPosition((pos) => {
        this.pos.lat = pos.coords.latitude;
        this.pos.lng = pos.coords.longitude;
        this.loadingGeolocation = false;
      });
    },
    startCamera() {
      if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({
          video: {
            width: { min: 852, ideal: 1280, max: 1920 },
            height: { min: 480, ideal: 720, max: 1080 },
            facingMode: this.facing,
          },
          audio: false,
        }).then((stream) => {
          video.srcObject = stream;
        }).catch((err) => {
          // console.error(err.message);
        });
      } else {
        this.cameraUnsupported = true;
      }
    },

    /**
     * Get absensi data from server
     *
     */
    getAbsensi(code) {
      video.pause();
      this.qrScanned = true;
      this.userInfoOpen = true;
      let theCode = '';
      if (code.indexOf('https://') >= 0) {
        /**
         * Parse code
         *
         */
        if (code.indexOf('undangan.icel.or.id') < 0) {
          this.apiError = 'Kode QR tidak dikenali, periksa kembali kode QR dan pastikan kode QR adalah kode QR dari undangan ICEL';
          return;
        }
        const codeArr = code.split('/');
        theCode = codeArr[codeArr.length - 1];
      } else {
        theCode = code;
      }
      this.loading = true;
      this.$http.get(this.$config.uri(`invitation/guest/${theCode}/detail`)).then((r) => {
        this.loading = false;
        if (r.data.status !== 200) {
          this.apiError = 'Tamu undangan tidak ditemukan';
          return;
        }
        this.user = r.data.data;
      }).catch((err) => {
        this.loading = false;
        this.apiError = (err.response && err.response.data && err.response.data.message)
          ? err.response.data.message : 'Internal server error';
      });
    },
    catatAbsen() {
      this.$refs.thankYou.open({
        title: 'Absen Sukses',
        desc: `Data absensi untuk ${this.user.name} sudah tercatat di sistem`,
        loading: true,
      }, (b) => {
        if (b) this.tryAgain();
      });
      this.$http.post(this.$config.uri(`invitation/guest/${this.user.invitationCode}/attendance`), {
        source: 'qr_scan',
      }).then((r) => {
        this.$refs.thankYou.stopLoading();
      }).catch((err) => {
        this.$refs.thankYou.close(false);
        this.absenError = (err.response && err.response.data)
          ? err.response.data.message : 'Internal server error';
      });
    },
    tryAgain() {
      this.qrScanned = false;
      this.userInfoOpen = false;
      this.loading = false;
      this.apiError = null;
      this.absenError = null;
      this.user = null;
      this.saving = false;
      video.play();
      setTimeout(() => {
        this.capture();
      }, 500);
    },
  },
  beforeDestroy() {
    if (captureTimer) clearTimeout(captureTimer);
  },
  mounted() {
    this.chTitle('QR Scaner Attendance');
    this.chCGB(true);

    this.qrReader.callback = (err, value) => {
      if (err) return;
      this.getAbsensi(value.result);
    };

    this.capture();
    this.startCamera();
    this.getPosition();

    window.scrollTo(0, 0);

    this.eventId = Number(this.$route.query.id);
    if (Number.isNaN(this.eventId)) return;
    this.$http.get(this.$config.uri(`invitation/${this.eventId}/detail`)).then((r) => {
      if (r.data.status !== 200) return;
      this.chTitle(`${r.data.data.name} / QR Scaner Attendance`);
      this.event = r.data.data;
    });
  },
};
</script>


<style scoped lang="scss">
#absensi{
  position: relative;
  padding: 0;
  overflow: hidden;
}
.camera{
  background-color: #222;
  height: 80vh;
  position: absolute;
  top: 0; left: 0; right: 0;
  overflow: hidden;
  @media (min-width: 681px) {
    height: 100vh;
  }
  canvas{
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    z-index: 3;
    display: none;
  }
  video{
    position: absolute;
    left: 50%; top: 50%;
    min-width: 100%;
    min-height: 100%;
    transform: translate(-50%, -50%); // scaleX(-1);
    z-index: 1;
  }
  .camera-change{
    z-index: 7;
    position: absolute;
    right: 60px; top: 17px;
    width: 24px; height: 24px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(../assets/cameraswitch_black_24dp.svg);
  }
  .location{
    z-index: 7;
    position: absolute;
    border: #3984e0 2px solid;
    right: 20px; top: 20px;
    width: 20px; height: 20px;
    border-radius: 50%;
    &:before{
      background-color: #3984e0;
      border-radius: 50%;
      content: "";
      position: absolute;
      top: 2px; right: 2px; left: 2px; bottom: 2px;
    }
    .loc-l{
      position: absolute;
      width: 2px; height: 5px;
      left: 50%; top: -5px;
      margin-left: -1px;
      background-color: #3984e0;
      &.l2{
        right: -5px;
        left: auto;
        top: 50%;
        margin-left: 0;
        margin-top: -1px;
        width: 5px;
        height: 2px;
      }
      &.l3{
        top: auto;
        bottom: -5px;
      }
      &.l4{
        left: -5px;
        top: 50%;
        margin-top: -1px;
        margin-left: 0;
        width: 5px;
        height: 2px;
      }
    }
    &.unsupported{
      border-color: #fff;
      opacity: .65;
      &:after{
        content: "";
        position: absolute;
        width: 2px;
        height: 180%;
        background-color: #fff;
        left: 50%;
        margin-left: -1px;
        top: -40%;
        transform: rotate(45deg);
      }
      &:before{
        background-color: #fff;
      }
      .loc-l{
        background-color: #fff;
      }
    }
    &.loading{
      border-color: #fff;
      opacity: 1;
      &:after{
        visibility: hidden;
      }
      .loc-l{
        background-color: #fff;
      }
      &:before{
        animation: loading-location .7s linear forwards infinite;
      }
    }
  }
  .backBtn{
    z-index: 7;
    position: absolute;
    cursor: pointer;
    left: 20px; top: 10px;
    width: 40px; height: 40px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(../assets/back-arrow.png);
    background-size: 22px auto;
    background-color: #fff;
    border-radius: 50%;
    display: none;
  }
  .logo{
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 600;
    color: #fff;
    z-index: 7;
    width: 80px;
    height: 38px;
    background-image: url(../assets/logo.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    @media (max-width: 680px) {
      height: 30px; width: 70px;
    }
  }
  .box{
    width: 80vw; height: 80vw;
    max-width: 400px;
    max-height: 400px;
    border-radius: 20px;
    border: #fff 3px solid;
    position: absolute;
    top: 50%; left: 50%;
    margin-top: -20px;
    transform: translate(-50%, -50%);
    z-index: 7;
    display: flex;
    align-items: center;
    justify-content: center;
    // display: none;
    @media (min-width: 681px) {
      margin-top: -100px;
      max-width: 380px;
      max-height: 380px;
    }
    &.unsupported{
      border-color: red;
      color: red;
      // background-color: rgba(255, 0, 0, .08);
      .camera-unsupported{
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px;
      }
    }
  }
}
@keyframes error-animation {
  0% { background-color: #fff; transform: translateY(0); }
  25% { background-color: #ffe9e9; transform: translateY(-10px); }
  50% { background-color: #fff; transform: translateY(0); }
  75% { background-color: #ffe9e9; transform: translateY(-10px); }
  100% { background-color: #fff; transform: translateY(0); }
}
.info{
  margin: calc(80vh - 60px) auto 0;
  background-color: #fff;
  border-radius: 10px 10px 0 0;
  max-width: 680px;
  transition: all .3s ease;
  position: relative;
  z-index: 7;
  @media (max-width: 1480px) {
    margin-top: calc(80vh - 90px);
  }
  &.open{
    margin-top: calc(80vh - 460px);
    @media (max-width: 1480px) {
      margin-top: calc(80vh - 580px);
    }
  }
  &.hasError{
    animation: error-animation .5s ease;
    .btn{
      margin-top: 16px;
      padding: 8px 24px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 50px;
      transition: all .3s ease;
    }
  }
  // @media (prefers-color-scheme: dark) {
  //   background-color: #222;
  // }
  .title{
    padding: 30px 20px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: #eee 1px solid;
    // @media (prefers-color-scheme: dark) {
    //   border-color: rgba(255, 255, 255, .06);
    // }
    .handle{
      position: absolute;
      top: 10px;
      left: 50%;
      width: 60px;
      margin-left: -30px;
      height: 6px;
      background-color: #e5e5e5;
      border-radius: 50px;
      // @media (prefers-color-scheme: dark) {
      //   background-color: #333;
      // }
    }
    h4{
      font-weight: 700;
      font-size: 20px;
      margin: 0;
      text-align: center;
    }
    button{
      margin-left: auto;
      border: #222 1px solid;
      border-radius: 50px;
      padding: 8px 20px;
      background-color: #fff;
      color: #444;
      font-size: 15px;
      font-weight: 600;
      // @media (prefers-color-scheme: dark) {
      //   background-color: #252525;
      //   color: #ccc;
      // }
    }
  }
  .user-cnt{
    min-height: 800px;
    .loading-user{
      height: 300px;
      background-image: url(../assets/loading-2.svg);
      background-size: 36px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    .please-take-photo{
      padding: 14px 20px 0;
      text-align: center;
      line-height: 1.2;
      max-width: 420px;
      margin: 0 auto;
      button.input-manual{
        background-color: #eee;
        border-radius: 50px;
        padding: 10px 24px;
        text-align: left;
        font-size: 17px;
        color: #767676;
        width: 100%;
        display: block;
        cursor: pointer;
        border: none;
        margin-top: 10px;
        transition: all .3s ease;
        position: relative;
        &:before{
          content: "";
          position: absolute;
          right: 16px; top: 0; bottom: 0;
          width: 20px;
          background-image: url(../assets/qr-code.png);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        &:hover{
          background-color: #e5e5e5;
        }
      }
      &.error{
        color: red;
        max-width: 380px;
        button.input-manual{
          display: none;
        }
      }
    }
    .user-main-cnt{
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      height: 520px;
      .btnCnt{
        position: absolute;
        left: 0; right: 0; bottom: 0;
        border-top: #eee 1px solid;
        text-align: right;
        padding: 14px 30px;
        .btn{
          margin-left: 10px;
        }
      }
    }
    .user-main{
      text-align: center;
      padding: 0 20px;
      margin-bottom: 40px;
      width: 100%;
      .avatar{
        position: relative;
        z-index: 3;
        margin: 0 auto 14px;
        width: 96px; height: 96px;
        background-color: #00B8A9;
        border-radius: 50%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        &.no-avatar{
          background-image: url(../assets/avatar.png);
          background-size: 60px auto;
          background-position: 50% 20px;
        }
      }
      p.yth{
        margin: 0;
      }
      p.position{
        margin: -10px 0 20px;
      }
      h4{
        margin: 0 0 10px;
        font-size: 20px;
        font-weight: 700;
      }
      .absen-error{
        color: red;
        text-align: center;
        font-size: 13px;
      }
      .absen-sukses{
        background-color: yellow;
        padding: 6px 14px;
        border-radius: 3px;
        font-size: 14px;
        display: inline-block;
        margin: 0 0 10px;
      }
      .user-info{
        width: 100%;
        max-width: 360px;
        margin: 0 auto 20px;
        .user-info-item{
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4px 0;
          span{
            white-space: nowrap;
            &.info-label{
              color: #767676;
            }
            &.the-info{
              margin-left: auto;
            }
          }
        }
      }
    }
  }
}

@keyframes loading-location {
  from {background-color: #fff;}
  to {background-color: transparent;}
}
</style>
